import { Button, Drawer, Flex, Result, theme } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ContactUs from "../Integrations/ContactUs";
import { isRtl } from "utils/locale";

const Feedback = ({ shouldOpen, status }: { shouldOpen: boolean; status: "success" | "error" }) => {
  const [open, setOpen] = useState(shouldOpen);
  const { t } = useTranslation();
  const { token } = theme.useToken();

  const handleClose = () => {
    setOpen(false);
    if (status === "success") {
      window.location.reload();
    }
  };

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      width="43%"
      placement={isRtl() ? "left" : "right"}
      closable={false}
    >
      <Result
        status={status}
        title={t(`templates.integrations.tahseel_activation.feedback.${status}.title`)}
        subTitle={t(`templates.integrations.tahseel_activation.feedback.${status}.description`)}
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        extra={
          <Flex gap={token.marginXS} vertical>
            <Button key="close" type="primary" size="large" onClick={handleClose}>
              {t("forms.buttons.done")}
            </Button>
            <ContactUs centered={true} />
          </Flex>
        }
      />
    </Drawer>
  );
};

export default Feedback;
